/*       */

import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { name, label, clearable, randomized } from 'app/utils/designer/form/settings/common/commonBase';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';
import { readOnly, staticAttribute } from 'app/utils/designer/form/settings/common/commonValidation';

const panels = settingsValues =>
    [
        {
            header: 'Base',
            // expanded: true,
            children: [name, label, clearable, randomized],
        },
        {
            header: 'Events',
            children: [onLoad, onChange, isVisible, settingsValues?.viewType !== 'class' && isDisabled].filter(Boolean),
        },
        settingsValues?.viewType === 'class' && {
            header: 'Validation',
            children: [readOnly, settingsValues?.viewType === 'class' && staticAttribute(settingsValues)],
        },
        {
            header: 'Styles',
            children: [flexGrow],
        },
        {
            header: 'Helpers',
            children: [help],
        },
    ].filter(Boolean);

export default {
    defaults: { clearable: false, randomized: false, withDefault: true },
    panels: settingValues => panels(settingValues),
};
